import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { Box } from '@chakra-ui/react';
const TooltipFC = ({ id, offset = 0, children }) => {
    return (_jsx(ReactTooltip, { id: id, noArrow: true, opacity: '1', delayShow: 250, offset: offset, closeEvents: {
            mouseleave: true
        }, style: {
            padding: '0',
            borderRadius: '24px',
            backgroundColor: 'white'
        }, children: _jsx(Box, { p: '4px 8px', fontSize: '14px', borderRadius: '24px', color: '{colors.textPrimary}', boxShadow: '{shadows.shadow_menu}', children: children }) }));
};
export const Tooltip = memo(TooltipFC);
//# sourceMappingURL=Tooltip.js.map